import PropTypes from "prop-types";
import ReactDom from "react-dom";
import "components/modal/Modal.scss";
import { Typography } from "core/typography/Typography";
import { useDismiss } from "utils/customHooks";

const DeliveryNotePreviewModalShell = ({
  id,
  title,
  onClose,
  children,
  actions,
}) => {
  useDismiss({ open: true, onDismiss: onClose, outsideClick: false });

  return ReactDom.createPortal(
    <>
      <div className="overlay-style" onClick={onClose} />
      <div className="modal-style delivery-note-preview-modal" id={id}>
        <Typography
          className="title-3 violet text-uppercase"
          type="h2"
          label={title}
        />
        <div className="delivery-note-preview-modal__body">{children}</div>
        <div className="delivery-note-preview-modal__buttons">{actions}</div>
      </div>
    </>,
    document.getElementById("portal")
  );
};

DeliveryNotePreviewModalShell.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  actions: PropTypes.node,
};

export default DeliveryNotePreviewModalShell;
